export const popularPlaces = [
    'Oslo',
    'Bergen',
    'Trondheim',
    'Gothenburg',
    'Copenhagen',
    'London',
    'Stockholm',
    'Amsterdam',
    'Gdańsk',
    'Paris',
    'Rome',
    'Edinburgh',
    'Alicante',
    'Málaga',
    'Barcelona',
    'Nice',
    'Antalya',
    'Istanbul',
    'Palma de Mallorca',
    'Alanya',
    'Split',
    'Athens',
    'Dubrovnik',
    'Marbella',
    'Kristiansand',
    'Stavanger',
    'Gardermoen',
    'Tromsø',
    'Bodø',
    'Ålesund',
    'Lillehammer',
    'Bangkok',
    'New York City',
    'Dubai',
    'Pattaya',
    'Gran Canaria',
    'Puerto Rico',
    'Lisbon',
    'Reykjavík',
] as const;

export const pickRandomPlace = () => popularPlaces[Math.floor(Math.random() * popularPlaces.length)];
